import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./cstyle.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import translations from "../locals/translation";
import { fetchDataReports, fetchDataStatements } from "../redux/reportSlice";
import { fetchQueries, fetchQueryStatements } from "../redux/querySlice";
import { fetchVendors } from "../redux/vendorSlice";
import { SyncLoader } from "react-spinners";
import { performVerification } from "../commonFunc/verification";
import Swal from "sweetalert2";

function Sidebar(visibility) {
  const dispatch = useDispatch();

  const language = useSelector((state) => state.language.value);

  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    dispatch(fetchDataReports());
    dispatch(fetchDataStatements());

    dispatch(fetchQueries(language));
    dispatch(fetchQueryStatements());

    dispatch(fetchVendors());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const { reportsData, loadingReports } = ((state) => state.reports);
  const { reportsStatements, loadingReportsStatements } = useSelector(
    (state) => state.reports
  );

  const { queryData, loadingQuery } = useSelector((state) => state.queries);
  const { queryStatements, loadingQueryStatements } = useSelector(
    (state) => state.queries
  );

  const { vendorData, loadingVendors } = useSelector((state) => state.vendors);

  return (
    <>
      <div className="sidebar-container">
        <div
          className={`sidebar ${visibility.visibility ? "active" : "inactive"}`}
        >
          <div className="sidebar-logo">
            <img src="./img/sideLogo.png" alt="logo" />
          </div>
          <h2
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            {t("DASHBOARD")}
          </h2>
          <h2
            onClick={() => {
              navigate("/locations");
            }}
          >
            {t("LOCATIONS")}
          </h2>

          <h2
            onClick={() => {
              if (!(loadingReports || loadingReportsStatements)) {
                navigate("/reports", {
                  state: {
                    statements: reportsStatements,
                    mainReports: reportsData,
                  },
                });
              }
            }}
          >
            {loadingReports || loadingReportsStatements ? (
              <SyncLoader color="#431018" style={{ padding: "10px 0px" }} />
            ) : (
              t("REPORTS")
            )}
          </h2>

          <h2
            onClick={() => {
              if (!(loadingQuery || loadingQueryStatements)) {
                navigate("/queries", {
                  state: {
                    statements: queryStatements,
                    mainReports: queryData,
                  },
                });
              }
            }}
          >
            {loadingQuery || loadingQueryStatements ? (
              <SyncLoader color="#431018" style={{ padding: "10px 0px" }} />
            ) : (
              t("QUERIES")
            )}
          </h2>

          <h2
            onClick={() => {
              if (!loadingVendors) {
                navigate("/vendorslist", { state: vendorData });
              }
            }}
          >
            {" "}
            {loadingVendors ? (
              <SyncLoader color="#431018" style={{ padding: "10px 0px" }} />
            ) : (
              t("VENDORS")
            )}
          </h2>

          <h2
            onClick={() => {
              if (!false) {
                navigate("/avatargallery", { state: vendorData });
              }
            }}
          >
            {" "}
            {false ? (
              <SyncLoader color="#431018" style={{ padding: "10px 0px" }} />
            ) : (
              t("GALLERY")
            )}
          </h2>

          <h2
            onClick={() => {
              if (!false) {
                navigate("/requests", { state: vendorData });
              }
            }}
          >
            {" "}
            {false ? (
              <SyncLoader color="#431018" style={{ padding: "10px 0px" }} />
            ) : (
              t("REQUESTS")
            )}
          </h2>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
